<style lang="scss" src='./TaskList.scss' scoped></style>
<template src="./TaskList.html"></template>

<script>
import TaskDetails from '@/views/task/details/TaskDetails.vue';
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'TaskList',
  components:{
    TaskDetails,
    UserAvatar,
  },
  props: {
    tasks: {
      required: false,
    },
    loading: {
      required: false,
    },
    orderBy: {
      required: true,
    },
  },
  data() {
    return ({
    });
  },

  computed:{
    tasksSorted: function() {
      const tasks = this.sortTasks(this.orderBy);
      return tasks;
    }
  },

  watch: {
  },

  methods: {
    sortTasks(orderBy) {
      if (! this.G_isEmptyArr(this.tasks)) {
        return this.tasks.sort((a, b) => {
          if (!a[orderBy] && !b[orderBy]) {
            return 0;
          }
          else if (a[orderBy] && !b[orderBy]) {
            return -1;
          } 
          else if (!a[orderBy] && b[orderBy]) {
            return 1;
          } 
          else {
            if (orderBy.includes("time")) {
              // Asc
              return String(b[orderBy]).localeCompare(String(a[orderBy]));
            } else {
              // Desc
              return String(a[orderBy]).localeCompare(String(b[orderBy]));
            }
          }
          return -1;
        });
      } else {
        return [];
      }
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
  },

  beforeDestroy(){}
};
</script>
